const styles = theme => ({

	root: {
		minWidth: 283,
		height: '100%',
		fontFamily: theme.typography.fontFamily,
	},
});

export default styles;